<template>
  <div>
    <a-modal
      @ok="handleOkDateModal"
      @cancel="handleCancelDateModal"
      v-model="bulletinPreview"
      :title="$t('bulletin.date')"
      :closable="false"
      :width="500"
      :height="700"
      :key="'bulletinDate'"
    >
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center flex-grow-1 mr-2">
          <label style="margin-right: 10px">{{ $t("bulletin.date") }}</label>
          <a-date-picker
            class="flex-grow-1"
            :allowClear="false"
            @change="
              (val) => {
                bulletinDate = val;
              }
            "
            :default-value="moment(new Date())"
            :disabled="!showDate"
            format="DD/MM/YYYY"
          />
        </div>
        <a-switch v-model="showDate" />
      </div>
      <div style="margin-top: 20px" v-if="allowStampField">
        <label style="margin-right: 10px">{{ $t("bulletin.showStamp") }}</label>
        <a-switch v-model="showStamp" />
      </div>
      <div style="margin-top: 20px" v-if="allowPersonalizedAverage">
        <label style="margin-right: 10px">{{
          $t("bulletin.PersonalizedAverage")
        }}</label>
        <a-switch v-model="usePersonalizedAverage" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { Modal } from "ant-design-vue";
import moment from "moment";
export default {
  name: "Bulletin",
  props: {
    on: {
      type: String,
      required: true,
      enum: ["student", "classroom"],
      default: "student",
    },
    selectedItem: {
      type: String,
      required: true,
    },
    students: {
      required: true,
    },
    incompleteMarksStats: {
      type: Object,
      required: true,
    },
    selectedTrimester: {
      type: String,
      required: true,
      default: "1",
    },
    type: {
      type: String,
      required: true,
      default: "MS",
    },
    personalized: {
      type: Boolean,
      required: true,
      default: false,
    },
    bulletinPreview: {
      type: Boolean,
      required: true,
      default: false,
    },
    allowPersonalizedAverage: {
      type: Boolean,
      required: true,
      default: false,
    },
    allowStampField: {
      type: Boolean,
      required: true,
      default: false,
    },
    templateId: {
      type: String,
      required: true,
      default: "",
    },
  },
  data() {
    return {
      bulletinDate: null,
      showStamp: true,
      showDate: true,
      usePersonalizedAverage: false,
    };
  },
  methods: {
    moment,
    async handleOkDateModal() {
      let missingMarks = [];
      if (this.on === "student") {
        this.students.modules?.forEach((m) => {
          m.subjects?.forEach((c) => {
            if (c.mark === "--" || c.mark == null) missingMarks.push(c.name);
          });
        });
        if (missingMarks.length !== 0) {
          console.info("missingMarks", missingMarks);
          const confirmed = await new Promise((resolve) => {
            Modal.confirm({
              title: this.$t("bulletin.confirmPrintMatieres", {
                count: missingMarks.length,
              }),
              content: (h) => {
                const list = missingMarks.map((s) => h("li", s));
                return h("ul", list);
              },
              okText: this.$t("bulletin.generateAnyway"),
              okType: "danger",
              cancelText: this.$t("action.annuler"),
              async onOk() {
                try {
                  resolve(true);
                } catch (error) {
                  console.error("Failed to print bulletin:", error);
                  resolve(false);
                }
              },
              onCancel() {
                resolve(false); // User cancelled
              },
            });
          });

          if (!confirmed) {
            this.$emit("closeBulletin");
            return;
          } else {
            this.$emit(
              "printBulletin",
              this.templateId,
              this.showStamp,
              this.bulletinDate,
              this.showDate
            );
          }
        } else {
          this.$emit(
            "printBulletin",
            this.templateId,
            this.showStamp,
            this.bulletinDate,
            this.showDate
          );
        }
      } else {
        if (this.incompleteMarksStats.students[this.selectedItem]?.length > 0) {
          const confirmed = await new Promise((resolve) => {
            Modal.confirm({
              title: this.$t("bulletin.confirmPrintEleves", {
                count:
                  this.incompleteMarksStats.students[this.selectedItem].length,
              }),
              content: (h) => {
                const list = this.incompleteMarksStats.students[
                  this.selectedItem
                ].map((s) => h("li", s));
                return h("ul", list);
              },
              okText: this.$t("bulletin.generateAnyway"),
              okType: "danger",
              cancelText: this.$t("action.annuler"),
              async onOk() {
                resolve(true);
              },
              onCancel() {
                resolve(false);
              },
            });
          });
          console.log("confirmed", confirmed);

          if (!confirmed) {
            this.$emit("closeBulletin");
            return;
          } else {
            this.$emit(
              "printBulletin",
              this.templateId,
              this.showStamp,
              this.bulletinDate,
              this.showDate
            );
          }
        } else {
          this.$emit(
            "printBulletin",
            this.templateId,
            this.showStamp,
            this.bulletinDate,
            this.showDate
          );
        }
      }
    },
    handleCancelDateModal() {
      this.$emit("closeBulletin");
    },
  },
};
</script>
